// import { LoadersComponent } from 'src/app/loaders/loaders.component';
// import { AMDModule } from './../amd.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterPipe } from 'src/app/search-filter.pipe.';
import { LoadersComponent } from '../../master/loaders/loaders.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from '../../master/loaders/loader.interceptor';



@NgModule({
  declarations: [
  SearchFilterPipe,
  LoadersComponent
  ]
  ,
  
  imports: [
    CommonModule,
    
  ],
  exports:[
    SearchFilterPipe,
    LoadersComponent 
  ],
  providers:[
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ]

})
export class PipeModuleModule { }

